import type { JSX } from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { PREVIEW_CHARACTER_LIMIT } from '../../../../../../constants';
import type { PreviewEmailContentBoxProps } from '../../../../types';

import { PreviewEmailContentSubject } from './components/PreviewEmailContentSubject';
import { PreviewEmailContentUpdate } from './components/PreviewEmailContentUpdate';
import { PreviewEmailCtaButtons } from './components/PreviewEmailCtaButtons';

export function PreviewEmailContentBox({ subject, body, imageDataUrl }: PreviewEmailContentBoxProps): JSX.Element {
	return (
		<div className="bg-background-overlay py-4">
			<div className="flex flex-col">
				<div className="mb-4 px-4">
					<Text as="h3" className="typography-secondary uppercase">
						<Translate value="corgi.petition_update.preview_modal.content_title" />
					</Text>
				</div>
				{imageDataUrl && (
					<div className="mb-4 overflow-hidden">
						<Image className="w-full" src={imageDataUrl} alt="" />
					</div>
				)}
				<PreviewEmailContentSubject text={subject} />
				<PreviewEmailContentUpdate contentHtml={body} limit={PREVIEW_CHARACTER_LIMIT} />
				<PreviewEmailCtaButtons />
			</div>
		</div>
	);
}
